"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ChevronRight } from "lucide-react";
export default function OurLegacy() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  return <section data-section-id="256075" id="our-legacy" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {}
        <div className="flex flex-col items-center mb-12 md:mb-16">
          <h1 className="font-default text-3xl md:text-5xl lg:text-6xl font-bold text-center tracking-tight" style={{
          color: "var(--primary)"
        }}>
            Our Legal Legacy
          </h1>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          {}
          <div ref={contentRef} className={`transition-all duration-700 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6">
              <p className="font-default text-foreground text-base md:text-lg leading-relaxed">
                <span className="text-4xl font-bold float-left mr-2 leading-none" style={{
                color: "var(--primary)"
              }}>S</span>terling Law Associates was founded on the principles of unshakeable stability and elite intelligence. For decades, we have served as the architectural foundation for our clients' most complex legal challenges, providing clarity in an ever-evolving landscape.
              </p>

              <p className="font-default text-foreground text-base md:text-lg leading-relaxed">
                Our senior partners bring a combined century of experience in family law and real estate, ensuring that every case is handled with the precision and power that our firm is known for. We don't just practice law; we define the standard of excellence.
              </p>

              <div className="space-y-3 md:space-y-4">
                <div className="flex items-start gap-3">
                  <span className="text-lg mt-1 shrink-0" style={{
                  color: "var(--primary)"
                }}>
                    •
                  </span>
                  <p className="font-default text-foreground text-sm md:text-base">
                    Established authority in high-stakes litigation
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-lg mt-1 shrink-0" style={{
                  color: "var(--primary)"
                }}>
                    •
                  </span>
                  <p className="font-default text-foreground text-sm md:text-base">
                    Strategic counsel for complex real estate portfolios
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-lg mt-1 shrink-0" style={{
                  color: "var(--primary)"
                }}>
                    •
                  </span>
                  <p className="font-default text-foreground text-sm md:text-base">
                    Unwavering commitment to professional integrity
                  </p>
                </div>
              </div>

              <Link to="/TheFirmPage">
                <Button variant="outline" className="mt-6 text-primary border-primary hover:bg-primary/10 rounded-md font-mono uppercase tracking-widest text-xs">
                  The Sterling Standard
                  <ChevronRight className="w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`transition-all duration-700 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/senior_partners_portrait.png" alt="Sterling Law Senior Partners" className="w-full h-auto rounded-md shadow-xl grayscale border-[10px] border-[#1a1c1e]" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/senior_partners_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/senior_partners_portrait.png-wvc-sizes" loading="lazy" decoding="async" />
              <div className="absolute inset-0 rounded-md border-2 -z-10 translate-x-4 translate-y-4 opacity-30" style={{
              borderColor: "var(--secondary)"
            }} />
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 md:mt-24 pt-12 md:pt-16 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <h3 className="font-default text-2xl md:text-3xl font-bold mb-2" style={{
              color: "var(--primary)"
            }}>
                35+
              </h3>
              <p className="font-mono text-foreground text-xs md:text-sm uppercase tracking-widest">
                Years of Practice
              </p>
            </div>
            <div className="text-center">
              <h3 className="font-default text-2xl md:text-3xl font-bold mb-2" style={{
              color: "var(--primary)"
            }}>
                $2B+
              </h3>
              <p className="font-mono text-foreground text-xs md:text-sm uppercase tracking-widest">
                Assets Protected
              </p>
            </div>
            <div className="text-center">
              <h3 className="font-default text-2xl md:text-3xl font-bold mb-2" style={{
              color: "var(--primary)"
            }}>
                100%
              </h3>
              <p className="font-mono text-foreground text-xs md:text-sm uppercase tracking-widest">
                Client Dedication
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}